<template>
	<div>
		<!--部门统计和个人统计-->
		<el-tabs type="border-card" class="maintab" style="overflow: auto">
			<el-tab-pane
				v-loading="unitLoading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(255, 255, 255, 0.8)">
				<span slot="label"><i class="el-icon-school"></i> 派审部门统计</span>
				<el-card class="searchItemFlex">
						<span>选择部门(类别)：</span> 
						<el-radio-group v-model="unitStatisticParams.paclass" size="mini">
							<el-radio-button
								v-for="item in paclassList"
								:key="item.clid"
								:label="item.clid"
								>{{ item.clname }}</el-radio-button
							>
						</el-radio-group>
						<span>选择年份：</span>
						<el-date-picker
							v-model="unitStatisticParams.yearStr"
							size="mini"
							type="year"
							style="width: 120px"
							placeholder="选择年份"
							value-format="yyyy">
						</el-date-picker>
						<el-button type="primary" size="mini" @click="getUnitStatisticData"
							><i class="el-icon-data-line"></i>&nbsp;统计生成</el-button
						>
						<el-tooltip
							content="各统计项有包含关系，如‘已交底’项目可能同时也是‘在审项目’，因此各项总和与总数可能不一致。"
							placement="top"
							effect="light">
							<i class="el-icon-info"></i>
						</el-tooltip>
				</el-card>
				<el-divider><i class="el-icon-search"></i></el-divider>
				<el-row :gutter="20" >
					<el-col :span="8"> &nbsp; </el-col>
					<el-col :span="8">
						<el-descriptions
							class="margin-top"
							title="综合信息"
							:column="2"
							size="mini"
							border
							v-show="unitStatisticInfoVisible">
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-s-grid"></i>项目总数
								</template>
								<el-tag type="success" size="mini">{{ unitProAllNum }}</el-tag>
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-coin"></i>纸电总额
								</template>
								<el-tag type="primary" size="mini">{{
									unitProAllMy === null ? 0.0 : unitProAllMy
								}}</el-tag>
							</el-descriptions-item>
						</el-descriptions>
					</el-col>
					<el-col :span="8"> &nbsp; </el-col>
				</el-row>
				<div
					style="width: 800px; height: 500px; margin: 20px auto"
					ref="unitChart"></div>
			</el-tab-pane>
			<el-tab-pane
				v-loading="personLoading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(255, 255, 255, 0.8)">
				<span slot="label"><i class="el-icon-user"></i> 派审个人统计</span>
				<el-card class="searchItemFlex">
					<span>选择主审人：</span>
					<el-select
						v-model="personStatisticParams.auditor"
						placeholder="选择主审人"
						size="mini"
						clearable>
						<el-option
							v-for="item in auditorList"
							:key="item.userId"
							:label="item.userName"
							:value="item.userId"></el-option>
					</el-select>
					<span>选择年份：</span>
					<el-date-picker
						v-model="personStatisticParams.yearStr"
						size="mini"
						type="year"
						style="width: 120px"
						placeholder="选择年份"
						value-format="yyyy">
					</el-date-picker>
					<el-button
						type="primary"
						size="mini"
						@click="getPersonStatisticData"
						><i class="el-icon-data-line"></i>&nbsp;统计生成</el-button
					>
					<el-tooltip
						content="此处统计以主审人为主体，将项目视为主审人负责的项目进行统计，不涉及交底人。"
						placement="top"
						effect="light">
						<i class="el-icon-info"></i>
					</el-tooltip>
				</el-card>
				<el-divider><i class="el-icon-search"></i></el-divider>
				<el-row :gutter="20">
					<el-col :span="8"> &nbsp; </el-col>
					<el-col :span="8">
						<el-descriptions
							class="margin-top"
							title="综合信息"
							:column="2"
							size="mini"
							border
							v-show="personStatisticInfoVisible">
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-s-grid"></i>项目总数
								</template>
								<el-tag type="success" size="mini">{{ personAllNum }}</el-tag>
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-coin"></i>纸电总额
								</template>
								<el-tag type="primary" size="mini">{{
									personAllMy === null ? 0.0 : personAllMy
								}}</el-tag>
							</el-descriptions-item>
						</el-descriptions>
					</el-col>
					<el-col :span="8"> &nbsp; </el-col>
				</el-row>
				<div
					style="width: 800px; height: 500px; margin: 20px auto"
					ref="personChart"></div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
const echarts = require("echarts")
export default {
	name: "auditStatistic",
	data() {
		return {
			//部门统计相关
			unitStatisticParams: {
				paclass: null,
				yearStr: null,
			}, //部门统计参数
			paclassList: [], //项目类别（部门）列表
			unitProAllNum: 0, //部门统计总个数
			unitProAllMy: 0.0, //部门统计总纸电金额
			unitLoading: false, //单位统计加载动画
			unitStatisticInfoVisible: false, //综合信息是否可见
			//个人统计相关
			personStatisticParams: {
				auditor: null,
				yearStr: null,
			}, //个人统计参数
			auditorList: [], //主审人列表
			personAllNum: 0, //个人统计总个数
			personAllMy: 0.0, //个人统计总纸电金额
			personLoading: false, //个人统计加载动画
			personStatisticInfoVisible: false, //综合信息是否可见
		}
	},
	mounted() {
		var date = new Date()
		this.unitStatisticParams.yearStr = date.getFullYear().toString()
		this.personStatisticParams.yearStr = date.getFullYear().toString()
		this.getAclassList()
		this.getDisAudList()
	},
	methods: {
		//获取项目类别列表
		async getAclassList() {
			const { data: res } = await this.$http.post("atimport/aclassList").catch(err => err)
			if (res) {
				const All = {
					clid: "Al",
					clname: "全部",
				}
				res.push(All)
				this.paclassList = res
			}
		},
		//获取部门年度统计数据
		async getUnitStatisticData() {
			//判断参数
			if (
				this.unitStatisticParams.paclass === null ||
				this.unitStatisticParams.yearStr === null
			) {
				return this.$message.warning("请完善统计参数（类别与年份）后再试！")
			}

			this.unitLoading = true
			const { data: res } = await this.$http.post(
				"auditStatic/unitStatic",
				this.unitStatisticParams
			).catch(err => err)
			if (res) {
				this.unitStatisticInfoVisible = true
				this.unitProAllNum = res.allNum
				this.unitProAllMy = res.zdMySum
				this.initUnitCharts(res.staticData)
				this.$message.success("统计完成。")
			}
			this.unitLoading = false
		},
		//部门年度统计图绘制
		initUnitCharts(statisticData) {
			let myChart = echarts.init(this.$refs.unitChart)
			// 绘制图表
			myChart.setOption({
				title: { text: "派审项目-按部门统计", left: "center" },
				tooltip: {},
				xAxis: {
					type: "category",
					data: ["待派项目", "已交底项目", "在审项目", "已完项目", "已结项目"],
				},
				yAxis: {
					type: "value",
					name: "项目数量",
				},
				series: [
					{
						name: "项目数量",
						type: "bar",
						showBackground: true,
						backgroundStyle: {
							color: "rgba(220, 220, 220, 0.8)",
						},
						label: {
							show: true,
							position: "top",
							color: "black",
							fontSize: 14,
						},
						itemStyle: {
							color: function (params) {
								//注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
								var colorList = [
									"#c23531",
									"#ca8622",
									"#61a0a8",
									"#91c7ae",
									"#2f4554",
								]
								return colorList[params.dataIndex]
							},
						},
						data: statisticData,
					},
				],
				itemStyle: {
					barBorderRadius: 5,
					borderWidth: 1,
					borderType: "solid",
					borderColor: "#73c0de",
					shadowColor: "#5470c6",
					shadowBlur: 3,
				},
				toolbox: {
					//show: true,
					itemSize: 20,
					itemGap: 30,
					right: 50,
					feature: {
						dataView: { show: true },
						saveAsImage: {
							//excludeComponents :['toolbox'],
							pixelRatio: 2,
						},
					},
				},
			})
		},

		//获取主审人列表
		//获取交底主审人列表
		async getDisAudList() {
			const { data: res } = await this.$http.post("atimport/disaudList").catch(err => err)
			if (res) {
				this.auditorList = res.audList
			}
		},
		//获取个人年度统计数据
		async getPersonStatisticData() {
			//判断参数
			if (
				this.personStatisticParams.auditor === null ||
				this.personStatisticParams.yearStr === null
			) {
				return this.$message.warning("请完善统计参数（主审人与年份）后再试！")
			}
			this.personLoading = true
			const { data: res } = await this.$http.post(
				"auditStatic/personStatic",
				this.personStatisticParams
			).catch(err => err)
			if (res) {
				this.personStatisticInfoVisible = true
				this.personAllNum = res.allNum
				this.personAllMy = res.zdMySum
				this.initPersonCharts(res.staticData)
				this.$message.success("统计完成。")
			}
			this.personLoading = false
		},
		//个人年度统计图绘制
		initPersonCharts(statisticData) {
			let myChart = echarts.init(this.$refs.personChart)
			// 绘制图表
			myChart.setOption({
				title: { text: "派审项目-按个人统计", left: "center" },
				tooltip: {},
				xAxis: {
					type: "category",
					data: ["已派项目", "已交底项目", "在审项目", "已完项目", "已结项目"],
				},
				yAxis: {
					type: "value",
					name: "项目数量",
				},
				series: [
					{
						name: "项目数量",
						type: "bar",
						showBackground: true,
						backgroundStyle: {
							color: "rgba(220, 220, 220, 0.8)",
						},
						label: {
							show: true,
							position: "top",
							color: "black",
							fontSize: 14,
						},
						itemStyle: {
							color: function (params) {
								//注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
								var colorList = [
									"#409eff",
									"#ca8622",
									"#61a0a8",
									"#91c7ae",
									"#2f4554",
								]
								return colorList[params.dataIndex]
							},
						},
						data: statisticData,
					},
				],
				itemStyle: {
					barBorderRadius: 5,
					borderWidth: 1,
					borderType: "solid",
					borderColor: "#73c0de",
					shadowColor: "#5470c6",
					shadowBlur: 3,
				},
				toolbox: {
					//show: true,
					itemSize: 20,
					itemGap: 30,
					right: 50,
					feature: {
						dataView: { show: true },
						saveAsImage: {
							//excludeComponents :['toolbox'],
							pixelRatio: 2,
						},
					},
				},
			})
		},
	},
}
</script>

<style></style>
